import {
  MY_CLAIM_LIST_REQUEST,
  MY_CLAIM_LIST_SUCCESS,
  MY_CLAIM_LIST_FAIL,
  MY_CLAIM_LIST_RESET,
  CLAIM_STATS_REQUEST,
  CLAIM_STATS_SUCCESS,
  CLAIM_STATS_FAIL,
  CLAIM_STATS_RESET,
  CLAIM_SINGLE_REQUEST,
  CLAIM_SINGLE_SUCCESS,
  CLAIM_SINGLE_FAIL,
  CLAIM_SINGLE_RESET,
  CLAIM_PENDING_REQUEST,
  CLAIM_PENDING_SUCCESS,
  CLAIM_PENDING_FAIL,
  CLAIM_PENDING_RESET,
  CLAIM_POST_REQUEST,
  CLAIM_POST_SUCCESS,
  CLAIM_POST_FAIL,
  CLAIM_POST_RESET,
  CLAIM_UPDATE_REQUEST,
  CLAIM_UPDATE_SUCCESS,
  CLAIM_UPDATE_FAIL,
  CLAIM_UPDATE_RESET,
  CLAIM_DELETE_REQUEST,
  CLAIM_DELETE_SUCCESS,
  CLAIM_DELETE_FAIL,
  CLAIM_DELETE_RESET,
} from "constants/claimConstants";

export const myListClaimReducer = (state = { myClaimsList: [] }, action) => {
  switch (action.type) {
    case MY_CLAIM_LIST_REQUEST:
      return { loading: true };
    case MY_CLAIM_LIST_SUCCESS:
      return { loading: false, myClaimsList: action.payload };
    case MY_CLAIM_LIST_FAIL:
      return { loading: false, error: action.payload };
    case MY_CLAIM_LIST_RESET:
      return [];
    default:
      return state;
  }
};

export const statsClaimReducer = (state = { claimsStats: [] }, action) => {
  switch (action.type) {
    case CLAIM_STATS_REQUEST:
      return { loading: true };
    case CLAIM_STATS_SUCCESS:
      return { loading: false, claimsStats: action.payload };
    case CLAIM_STATS_FAIL:
      return { loading: false, error: action.payload };
    case CLAIM_STATS_RESET:
      return [];
    default:
      return state;
  }
};

export const singleClaimReducer = (state = { claimSingle: {} }, action) => {
  switch (action.type) {
    case CLAIM_SINGLE_REQUEST:
      return { loading: true };
    case CLAIM_SINGLE_SUCCESS:
      return { loading: false, claimSingle: action.payload };
    case CLAIM_SINGLE_FAIL:
      return { loading: false, error: action.payload };
    case CLAIM_SINGLE_RESET:
      return {};
    default:
      return state;
  }
};

export const pendingClaimReducer = (state = { claimsPending: [] }, action) => {
  switch (action.type) {
    case CLAIM_PENDING_REQUEST:
      return { loading: true };
    case CLAIM_PENDING_SUCCESS:
      return { loading: false, claimsPending: action.payload };
    case CLAIM_PENDING_FAIL:
      return { loading: false, error: action.payload };
    case CLAIM_PENDING_RESET:
      return [];
    default:
      return state;
  }
};

export const postClaimReducer = (state = { claimsPost: {} }, action) => {
  switch (action.type) {
    case CLAIM_POST_REQUEST:
      return { loading: true, success: false, error: false };
    case CLAIM_POST_SUCCESS:
      return { loading: false, claimsPost: action.payload, success: true, error: false };
    case CLAIM_POST_FAIL:
      return { loading: false, error: action.payload, success: false };
    case CLAIM_POST_RESET:
      return {};
    default:
      return state;
  }
};

export const updateClaimReducer = (state = { claimsUpdate: {} }, action) => {
  switch (action.type) {
    case CLAIM_UPDATE_REQUEST:
      return { loading: true };
    case CLAIM_UPDATE_SUCCESS:
      return { loading: false, claimsUpdate: action.payload, success: true };
    case CLAIM_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case CLAIM_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const deleteClaimReducer = (state = { claimsDelete: {} }, action) => {
  switch (action.type) {
    case CLAIM_DELETE_REQUEST:
      return { loading: true };
    case CLAIM_DELETE_SUCCESS:
      return { loading: false, claimsDelete: action.payload, success: true };
    case CLAIM_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case CLAIM_DELETE_RESET:
      return {};
    default:
      return state;
  }
};
